import { InformationCircleIcon } from "@heroicons/react/24/outline";
import clsx from "clsx";
import { useEffect, useRef, useState } from "react";

const LabelWithTooltip = ({ label, explanation }) => {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const close = (e) => {
      if (ref.current && !ref.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", close);
    document.addEventListener("touchstart", close);
    return () => {
      document.removeEventListener("mousedown", close);
      document.removeEventListener("touchstart", close);
    };
  }, []);

  return (
    <label className="flex items-center gap-1 text-xs text-gray-500 mb-1">
      <span dangerouslySetInnerHTML={{ __html: label }} />

      {explanation && (
        <span ref={ref} className="relative group">
          <InformationCircleIcon
            className="w-4 h-4 text-gray-400 cursor-pointer"
            onClick={(e) => {
              e.stopPropagation();
              setOpen((v) => !v);
            }}
          />

          <span
            className={clsx(
              "absolute z-20 w-[35vw] md:w-[190px] p-2 text-xs text-white bg-black rounded-md shadow-lg",
              "top-6 left-1/2 -translate-x-1/2",
              "hidden group-hover:block",
              open && "block"
            )}
          >
            {explanation}
            <span className="absolute -top-1 left-1/2 -translate-x-1/2 w-2 h-2 bg-black rotate-45" />
          </span>
        </span>
      )}
    </label>
  );
};

export default LabelWithTooltip;
